<cs-header>
  <cs-header-title>{{ titleText }}</cs-header-title>
</cs-header>
<cs-content>
  <cs-item-list>
    <div class="message">{{ messageText }}</div>
    <div class="help">{{ errorHelpText }}</div>
    @if (showResetLocalData) {
      <div class="message">{{ resetLocalDataOfferText }}</div>
      <cs-button secondary medium (click)="resetLocalData()" [label]="LL.fatalError.buttons.resetLocalData()"></cs-button>
    }
    @if (showLogout) {
      <cs-button secondary medium (click)="logout()" [label]="LL.fatalError.buttons.logout()"></cs-button>
    }
    <div class="support">
      {{ LL.fatalError.support.prefix() }}
      <a href="mailto:support@mh-physique.app">support&#64;mh-physique.app</a>
    </div>
  </cs-item-list>
</cs-content>
@if (showRetry) {
  <cs-page-action-buttons>
    <cs-button primary medium (click)="retry()" [label]="LL.fatalError.buttons.retry()"></cs-button>
  </cs-page-action-buttons>
}